// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";

import {getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import {getAnalytics} from "firebase/analytics";
import {getAuth, GoogleAuthProvider} from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBPe5L3NBmJZccPkunmthPmROzroiwHFpM",
  authDomain: "lecturersevaluator.firebaseapp.com",
  projectId: "lecturersevaluator",
  storageBucket: "lecturersevaluator.appspot.com",
  messagingSenderId: "503228624521",
  appId: "1:503228624521:web:5b8daf89465af378176058"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
export const db = getFirestore(app);
// connectFirestoreEmulator(db, 'localhost', 8083);